
import React from 'react';

interface IProps {
  style?: any;
  
}

export const RhombusIcon:React.FC<IProps> = (props: IProps) => {
  return (
    <svg width="100" height="100"  fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M50 0 95 45 50 90 5 45 " fill="#dee2eb"/>
   </svg>

    
  )
}
